export default "/images/d0f9857fb8e4f2b9e275607e3a5d0501.avif";